const v36 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        invoicesTable: {
          ...state.options.tableViews.invoicesTable,
          'Freelancer Notes': true,
        },
      },
    },
  };
};

export default v36;
